import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { VerifyEmailFeature } from "@/features/auth/VerifyEmailFeature";

const verifyEmailSearchSchema = z.object({
  token: z.string().optional(),
  redirect: z.string().optional(),
});

function VerifyEmailPage() {
  const { token, redirect } = Route.useSearch();
  return <VerifyEmailFeature token={token} redirectAfterVerify={redirect} />;
}

export const Route = createFileRoute("/(auth)/verify-email")({
  validateSearch: verifyEmailSearchSchema,
  component: VerifyEmailPage,
  staticData: { authorize: false },
});
